import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { adminDocumentState } from "@/const";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { DocumentStateBadge } from "@components/Game/Misc";
import { DevModal } from "@components/Helpers";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function Documents() {
    const { t } = useTranslation();
    const { apiData, setApiReget } = useAppApi(url_reverse("api:finstatements:documents"));
    const [showModal, setShowModal] = useState(null);
    const { api_delete } = useRequest();

    if (!apiData) return;

    const getFile = (developer, signed = false) => {
        const month = apiData.forms_data?.main.data.month;
        const year = apiData.forms_data?.main.data.year;
        const signed_param = signed ? "&signed=1" : "";
        window.open(
            url_reverse("devs:edit", { dev_id: developer.id }) +
                "developer_document_file/" +
                `?month=${month}&year=${year}` +
                signed_param
        );
    };

    const delFile = (ev) => {
        const month = apiData.forms_data?.main.data.month;
        const year = apiData.forms_data?.main.data.year;
        api_delete(
            ev,
            url_reverse("api:finstatements:documents:upload") +
                `?developer_id=${ev.target.value}&month=${month}&year=${year}`,
            {
                then: (resp) => {
                    if (resp.status === "ok") setApiReget(true);
                },
            }
        );
    };

    return (
        <ListingCard header={t("Документы на подпись")}>
            <RenderForm colLabel={2} colField={10} submitButtonText={t("Найти")} submitMethod="get" />

            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "30%" }}>{t("Компания")}</th>
                        <th style={{ width: "25%" }}>Email</th>
                        <th style={{ width: "20%" }}>{t("Статус")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.developer.id}`}>
                                <td>
                                    <a href={url_reverse("devs:edit", { dev_id: o.developer.id })}>
                                        {o.developer.company_ru || o.developer.name}
                                    </a>
                                </td>
                                <td>{o.developer.contact_email}</td>
                                <td>
                                    <DocumentStateBadge state={o.state} text={adminDocumentState[o.state]} />
                                </td>
                                <td>
                                    {o.file && (
                                        <>
                                            <DevForm.Button
                                                variant="info"
                                                size="sm"
                                                name="download"
                                                onClick={() => {
                                                    getFile(o.developer, o.state === "signed");
                                                }}
                                            >
                                                {t("Скачать")}
                                            </DevForm.Button>{" "}
                                            <DevForm.Button
                                                variant="danger"
                                                size="sm"
                                                name="delete"
                                                value={o.developer.id}
                                                onClick={delFile}
                                            >
                                                {t("Удалить")}
                                            </DevForm.Button>
                                        </>
                                    )}{" "}
                                    {o.state === "new" && (
                                        <DevForm.Button
                                            variant="success"
                                            size="sm"
                                            name="show_modal"
                                            onClick={() => {
                                                setShowModal(o.developer);
                                            }}
                                        >
                                            {t("Загрузить файлы")}
                                        </DevForm.Button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <DocumentFileUploadModal
                showModal={showModal}
                setShowModal={setShowModal}
                month={apiData.forms_data?.main.data.month}
                year={apiData.forms_data?.main.data.year}
            />
        </ListingCard>
    );
}

export function DocumentFileUploadModal({ showModal, setShowModal, month, year }) {
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    const apiUploadUrl = url_reverse("api:finstatements:documents:upload");
    const { api_post_formdata } = useRequest();

    const onSubmit = (ev) => {
        ev.preventDefault();
        if (confirm(t("Подтвердите своё действие"))) {
            const formData = new FormData();
            [...files].forEach((file) => {
                formData.append("main-docfiles", file);
            });
            formData.append("main-developer_id", showModal.id);
            formData.append("main-month", month);
            formData.append("main-year", year);
            api_post_formdata(ev, apiUploadUrl, formData, {
                then: (resp) => {
                    if (resp.status === "ok") {
                        setShowModal(false);
                        location.reload();
                    }
                    if (resp.status === "fail") {
                        alert(JSON.stringify(resp.errors, null, 2));
                    }
                },
            });
        }
    };

    return (
        <DevModal
            show={showModal}
            onHide={setShowModal}
            header={t("Документы")}
            body={
                <Form.Control
                    type="file"
                    multiple
                    name="docfiles"
                    onChange={(e) => setFiles(e.target.files)}
                    accept=".pdf,.png,.jpg,.jpeg,.tif,.tiff"
                />
            }
            footer={
                <DevForm.Button variant="primary" type="submit" name="submit">
                    {t("Подтвердить и отправить")}
                </DevForm.Button>
            }
            renderWrapper={(children) => <Form onSubmit={onSubmit}>{children}</Form>}
        />
    );
}
